export default __webpack_public_path__ + "static/media/1871.d459fa67.png";